import React from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {px} from '../../utils';

const NotFound = () => {
  return (
    <View style={styles.heading}>
      <Text style={styles.text}>No data found!</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  heading: {textAlign: 'center', paddingTop: px(30)},
  text: {fontSize: 20, textAlign: 'center'},
});

export default NotFound;
